import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { ListItem, Avatar } from "material-ui";
import { grey300 } from "material-ui/styles/colors";
import Account from "material-ui/svg-icons/action/account-circle";
import { translate } from "react-i18next";

class DashboardEventFeedItem extends Component {
  insertDate = (date) => {
    const { t } = this.props;
    if (moment(date).format("YYYY–MM–DD") === moment().format("YYYY–MM–DD")) {
      return t("Сегодня");
    }
    if (
      moment(date).format("YYYY–MM–DD") ===
      moment()
        .day("yesterday")
        .format("YYYY–MM–DD")
    ) {
      return t("Вчера");
    }
    return moment(date).format("DD MMMM");
  };

  render() {
    const event = { ...this.props.event, ...this.props.guests[this.props.event.user_id] };
    const { event_type: eventType } = event;
    const { t } = this.props;
    return (
      <div style={styles.wrapper}>
        <Link to={`/chats/${event.user_id}`} style={{ textDecoration: "none", color: "black" }}>
          <div style={styles.row}>
            <span style={styles.eventDate}>{this.insertDate(event.event_time)}</span>
            <span style={{ flex: 1 }}>
              <b>{t(eventData[eventType].title)}</b>
            </span>
          </div>
          <ListItem
            leftAvatar={<Avatar src={event.photo} icon={<Account />} />}
            primaryText={event.name}
            secondaryText={t(eventData[eventType].subtitle)}
            secondaryTextLines={2}
            hoverColor="transparent"
          />
        </Link>
      </div>
    );
  }
}

const eventData = {
  birthday: { title: "День рождения", subtitle: "Поздравим?" },
  new_guest: {
    title: "Новый гость",
    subtitle: "Оставьте о себе хорошее впечатление",
  },
  new_regular: {
    title: "Гость стал постоянным",
    subtitle: "Он сделал пятый заказ",
  },
  feedback: { title: "Новый отзыв о заказе", subtitle: "Поздравим?" },
};

const styles = {
  nestedBlock: {
    padding: "5px",
    display: "flex",
    borderBottom: "1px solid #777",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    alignContent: "flex-start",
    fontSize: "12px",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    borderBottom: `1px solid ${grey300}`,
  },
  row: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignContent: "center",
    alignItems: "center",
  },
  eventDate: {
    marginRight: "10px",
    flexBasis: 65,
    fontSize: "12px",
    color: "#777",
    textAlign: "center",
  },
};

const mapStateToProps = ({ guests }) => ({
  guests: guests.listById,
});

export default connect(mapStateToProps)(translate()(DashboardEventFeedItem));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardEventFeedItem.js